import React from 'react'
import LocationService from '../Service/locationService'
import LocationLevelService from '../Service/locationLevelService'

import FormInput from './formInput'
import ModalHapus from './modalHapus'
import ModalHapusError from './modalHapusError'
import ModalHapusBerhasil from './modalHapusBerhasil'
import ModalBerhasilSimpan from './modalBerhasilSimpan'
import ModalGagalSimpan from './modalGagalSimpan'
import ModalBerhasilUbah from './modalBerhasilUbah'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { config } from '../Config/config'
// import SelectSearch from 'react-select-search'
import './location.css'
import ModalEditError from './modalEditError'


export default class index extends React.Component {

    LocationModel = {
        // _id: "",
        name: "",
        // parent:"",
        // parent_id: "",
        location_level_id: "",
        created_by: localStorage.getItem(config.userid),
        modified_by: localStorage.getItem(config.userid),
        deleted_by: localStorage.getItem(config.userid),
        is_delete: false
    }

    constructor() {
        super()
        this.state = {
            List: [],
            ListLocationLevel: [],
            ListLocation: [],
            ListLocation2: [],
            ListLocation3: [],
            Model: this.LocationModel,
            Mode: "",
            ShowModal: false,
            ShowModalBerhasilSimpan: false,
            ShowModalGagalSimpan: false,
            ShowModalBerhasilUbah: false,
            ShowModalDel: false,
            ShowModalDelBerhasil: false,
            ShowModalDelErr: false,
            ShowModalEditErr: false,
            errors: {},
            TotalPage: 0,
            count: 0,
            filter: {
                search1: '',
                search2: '',
                // order: '',
                page: '1',
                pagesize: '10'

            },
            resLokasi: "",
            resLokasiParent: "",
            resName: "",

        }
    }

    //function untuk mengambil semua data di DB Variant di backend
    //memanggil API
    loadlist = async () => {

        const respond = await LocationService.getAllSearch(this.state.filter)
        const respondLocationLevel = await LocationLevelService.getAllData()
        const respondLocation = await LocationService.getAllData()
        const respondCount = await LocationService.countData(this.state.filter)
        const respondLokasi = await LocationService.getAll(this.state.filter)

        console.log(respond)

        if (respond.success) {
            // let count = respondCount.result.count
            let count = respond.result[0]
            if (count != null) {
                let hitung = count.jumlah
                this.setState({
                    List: respond.result,
                    ListLocationLevel: respondLocationLevel.result,
                    ListLocation: respondLocation.result, TotalPage: Math.ceil(hitung / this.state.filter.pagesize),
                    ListLocation2: respondLokasi.result

                })
            } else {
                let hitung = 0
                this.setState({
                    List: respond.result,
                    ListLocationLevel: respondLocationLevel.result,
                    ListLocation: respondLocation.result, TotalPage: Math.ceil(hitung / this.state.filter.pagesize),
                    ListLocation2: respondLokasi.result

                })

            }
            console.log(respondCount.result)
            // this.setState({
            //     List: respond.result,
            //     ListLocationLevel: respondLocationLevel.result,
            //     ListLocation: respondLocation.result,
            //     // ListLocationSearch : 

            //     TotalPage: Math.ceil(count / this.state.filter.pagesize)

            // })
        }
        console.log(this.state.List)
        console.log(this.state.ListLocationLevel)
        console.log(this.state.ListLocation)
    }


    loadlist2 = async () => {

        const respond = await LocationService.getAllSearch(this.state.filter)
        const respondLocationLevel = await LocationLevelService.getAllData()
        const respondLocation = await LocationService.getAllData()
        const respondCount = await LocationService.countData(this.state.filter)
        const respondLokasi2 = await LocationService.getAllKeywords(this.state.filter)

        console.log(respondLokasi2)

        if (respondLokasi2.success) {
            // let count = respondCount.result.count
            console.log(respondLokasi2.result)
            if (respondLokasi2.result == 0) {
                alert("Data tidak ada")
                this.loadlist()
            }
            else {
                let count = respondLokasi2.result[0]
                if (count != null) {
                    let hitung = count.jumlah
                    this.setState({
                        List: respond.result,
                        ListLocationLevel: respondLocationLevel.result,
                        ListLocation: respondLocation.result, TotalPage: Math.ceil(hitung / this.state.filter.pagesize),
                        ListLocation2: respondLokasi2.result

                    })
                } else {
                    let hitung = 0
                    this.setState({
                        List: respond.result,
                        ListLocationLevel: respondLocationLevel.result,
                        ListLocation: respondLocation.result, TotalPage: Math.ceil(hitung / this.state.filter.pagesize),
                        ListLocation2: respondLokasi2.result

                    })

                }
                console.log(respondCount.result)

            }
            // let count = respond.result[0]
            // if (count != null) {
            //     let hitung = count.jumlah
            //     this.setState({
            //         List: respond.result,
            //         ListLocationLevel: respondLocationLevel.result,
            //         ListLocation: respondLocation.result, TotalPage: Math.ceil(hitung / this.state.filter.pagesize),
            //         ListLocation2: respondLokasi.result

            //     })
            // } else {
            //     let hitung = 0
            //     this.setState({
            //         List: respond.result,
            //         ListLocationLevel: respondLocationLevel.result,
            //         ListLocation: respondLocation.result, TotalPage: Math.ceil(hitung / this.state.filter.pagesize),
            //         ListLocation2: respondLokasi.result

            //     })

            // }
            // console.log(respondCount.result)
            // this.setState({
            //     List: respond.result,
            //     ListLocationLevel: respondLocationLevel.result,
            //     ListLocation: respondLocation.result,
            //     // ListLocationSearch : 

            //     TotalPage: Math.ceil(count / this.state.filter.pagesize)

            // })
        }
        console.log(this.state.List)
        console.log(this.state.ListLocationLevel)
        console.log(this.state.ListLocation)
    }

    componentDidMount() {
        this.loadlist()
        // console.log(this.VariantModel)
        //untuk cek CategoryModel udah ada di inspect browser
    }

    pageSizeHandler = (size) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["pagesize"]: size
            }
        }, () => this.loadlist())
    }

    changePageHandler = (number) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["page"]: number
            }
        }, () => this.loadlist())
    }

    renderPagination() {
        let item = []
        for (let number = 1; number <= this.state.TotalPage; number++) {
            item.push(
                <PaginationItem key={number} active={number === this.state.filter}>
                    <PaginationLink onClick={() => this.changePageHandler(number)}>{number} </PaginationLink>
                    {/* //{number} ==> panggil variabel number dari variabel for(let number=1) */}
                </PaginationItem>
            )
        }
        return (
            <Pagination> { item}</Pagination >
        )
    }

    // getLocation = async (selectedOption) => {
    //     const respond = await LocationService.getByLocationLevelId(selectedOption)
    //     if (respond.success) {
    //         this.setState({
    //             ListLocation: respond.result
    //         })
    //     }
    // }

    //funct untuk masukan input ke VariantModel
    //buat simpan data semendata dari form input
    //
    changeHandler = field => ({ target: { value } }) => {

        // if (field == "location_level_id") {
        //     this.getLocation(value)
        // }

        this.setState({
            Model: {
                ...this.state.Model,
                [field]: value
            }
        })
        // console.log(this.state.Model.location_level_id)
    }

    //function untuk CHECKED
    checkedHandler = field => ({ target: { checked } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: checked
            }
        })
    }


    //button submit
    saveHandler = async () => {
        const responsParent = await LocationService.cekWilayahByNameParent(this.state.Model.name)
        const responsLocation = await LocationService.cekWilayahByNameLocation(this.state.Model.name)
        // const respons = await LocationService.cekWilayahByName(this.state.Model)

        var name = {}
        // if (respons.success) {
        //     name = respons.result
        // }
        if (responsParent.success) {
            name = responsParent.result
            // console.log(responsParent.result)
            if (responsLocation.success) {
                name = responsLocation.result
                // console.log(responsLocation.result)
                if (this.state.Mode == "Hapus Lokasi") {
                    // console.log(this.handleValidationLokasi())
                    this.state.Model.modified_by = localStorage.getItem(config.userid)
                    this.state.Model.deleted_by = localStorage.getItem(config.userid)

                    if (this.handleValidationParent()) {
                        if (this.handleValidationLokasi()) {

                            this.state.Model.is_delete = true
                            // console.log("1")
                            console.log("Data Kosong")
                            //mengubah is_delete yang dihapus dari false menjadi true
                            //hilang dr output, masih ada di db

                            const respond = await LocationService.editDataDelete(this.state.Model)
                            if (respond.success) {
                                // alert("Succes Delete Data")
                                // this.loadlist()
                                this.setState({
                                    Model: this.LocationModel,
                                    ShowModalDel: false,
                                    ShowModalDelBerhasil: true
                                })
                                this.loadlist()
                                console.log(respond)
                            } else {
                                console.log("Data tidak kosong")
                                // console.log("2")
                            }
                        }
                    } else {
                        console.log("Data tidak kosong")
                        // console.log("2")
                    }

                }

            }
        }



        // }
        const responsEdit = await LocationService.cekWilayahByNameEdit(this.state.Model)

        var name = {}
        if (responsEdit.success) {
            name = responsEdit.result
        }
        if (this.handleValidationEdit(name)) {
            // const responsNama = await LocationService.cekWilayahByName(this.state.Model)

            // var name = {}
            // if (responsNama.success) {
            //     name = responsNama.result
            //     console.log(responNama.result)
            // }


            if (this.state.Mode == "Ubah Lokasi") {
                const respond = await LocationService.editData(this.state.Model)
                this.state.Model.modified_by = localStorage.getItem(config.userid)
                // const responsNama = await LocationService.cekWilayahByName(this.state.Model)

                // if (responsNama.success) {
                //     name = responsNama.result
                //     console.log(responsNama.result)
                // }
                if (respond.success) {
                    // alert("Success Update Data")
                    // this.loadlist()
                    this.setState({
                        Model: this.LocationModel,
                        ShowModal: false,
                        ShowModalBerhasilUbah: true,
                    })
                    this.loadlist()

                }
                // else {
                //     this.setState({
                //         Model: this.LocationModel,
                //         ShowModal: false,
                //         ShowModalDelErr: true
                //     })
                //     this.loadlist()

                // }
                // }
            }

        }
        else {
            // alert("Form has errors")
            // this.setState({
            //     ShowModalGagalSimpan: true
            // })
        }

        const respons = await LocationService.cekWilayahByName(this.state.Model)

        var name = {}
        if (respons.success) {
            name = respons.result
        }
        if (this.handleValidation(name)) {
            // const responsNama = await LocationService.cekWilayahByName(this.state.Model)

            // var name = {}
            // if (responsNama.success) {
            //     name = responsNama.result
            //     console.log(responNama.result)
            // }


            if (this.state.Mode == "Tambah Lokasi") {

                const respond = await LocationService.addData(this.state.Model)
                // const responsNama = await LocationService.cekWilayahByName(this.state.Model)
                // var name={}
                // if (responsNama.success) {
                //     name = responsNama.result
                //     console.log(responsNama.result)

                // }
                if (respond.success) {
                    // alert("Succes Save Data")
                    this.loadlist()
                    this.setState({
                        Model: this.LocationModel,
                        ShowModal: false,
                        ShowModalBerhasilSimpan: true
                        // ShowModalGagalSimpan: true
                    })
                    this.loadlist()
                    // console.log(respond)
                } else {
                    this.loadlist()
                    this.setState({
                        ShowModal: false,
                        ShowModalGagalSimpan: true
                    })
                }
                // }
            }
        }
        else {
            // alert("Form has errors")
            // this.setState({
            //     ShowModalGagalSimpan: true
            // })
        }
        console.log(this.state.Model)




    }


    //UBAH LOKASI
    editHandler = async (_id) => {
        const respond = await LocationService.getById(_id)

        console.log(respond)

        this.setState({
            Mode: "Ubah Lokasi",
            ShowModal: true
        })

        if (respond.success) {
            this.setState({
                Model: respond.result
            })
        }
    }

    //TAMBAH LOKASI
    createHandler = () => {
        this.setState({
            Mode: "Tambah Lokasi",
            ShowModal: true,
            // ShowModalBerhasilSimpan: true,
            Model: this.LocationModel
        })
        console.log(this.state.ShowModal)

    }

    cancelHandler = () => {
        this.setState({
            Mode: "",
            ShowModal: false,
            ShowModalDel: false,
            ShowModalDelBerhasil: false,
            ShowModalDelErr: false,
            ShowModalBerhasilSimpan: false,
            ShowModalGagalSimpan: false,
            ShowModalBerhasilUbah: false,
            ShowModalEditErr: false,
            errors: {}
        })

    }

    cancelHandlerReset = () => {
        window.location.reload()
        // this.setState({
        //     filter: {
        //         search1: ""
        //     }
        // })
    }

    //filter
    filterHandler = field => ({ target: { value } }) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    //filter2
    filterHandler2 = field => ({ target: { value } }) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    handleValidation(name) {
        let fields = this.state.Model;
        let errors = {};
        let formIsValid = true;
        let checkName = this.state.resName;


        //Level Lokasi
        if (!fields["location_level_id"]) {
            formIsValid = false;
            errors["location_level"] = "* Level Lokasi harus diisi";
        }

        //Name
        if (!fields["name"]) {
            formIsValid = false;
            errors["name"] = "* Nama harus diisi";
        }

        else if (!fields["name"] || fields["name"].trim() == "") {
            formIsValid = false
            errors["nameEmpty"] = "* Nama tidak boleh kosong"
        }

        //Cek nama lokasi bila udah ada
        else if (name != undefined) {
            formIsValid = false;
            errors["name_existed"] = "* Nama sudah ada untuk wilayah tersebut";
            // this.setState.ShowModalGagalSimpan = true
        }
        this.setState({ errors: errors });
        return formIsValid;

    }

    handleValidationEdit(name) {
        let fields = this.state.Model;
        let errors = {};
        let formIsValid = true;
        let checkName = this.state.resName;


        //Level Lokasi
        if (!fields["location_level_id"]) {
            formIsValid = false;
            errors["location_level"] = "* Level Lokasi harus diisi";
        }
        //Name
        else if (!fields["name"]) {
            formIsValid = false;
            errors["name2"] = "* Nama harus diisi";
        }

        else if (!fields["name"] || fields["name"].trim() == "") {
            formIsValid = false
            errors["nameEmpty2"] = "* Nama tidak boleh kosong"
        }
        else if (name != undefined) {
            formIsValid = false;
            errors["name_existed"] = "* Nama sudah ada untuk wilayah tersebut";
            // this.setState.ShowModalGagalSimpan = true
        }
        else {
            console.log("2")
            //lokasi aktif
            formIsValid = false;
            this.setState({ ShowModalEditErr: true, ShowModalDel: false })
        }

        this.setState({ errors: errors });
        return formIsValid;

    }

    handleValidationParent() {
        let fields = this.state.Model;
        let errors = {};
        let formIsValid = true;
        let checkParent = this.state.resLokasiParent;

        console.log(checkParent)
        if (checkParent == "") {
            formIsValid = true;
            console.log("1")
        } else {
            console.log("2")
            //lokasi aktif
            formIsValid = false;
            // this.setState({ ShowModalDelErr: true, ShowModalDel: false })
            this.setState({ShowModalDel: false })
        }
        return formIsValid
    }


    handleValidationLokasi() {
        let fields = this.state.Model;
        let errors = {};
        let formIsValid = true;
        let check = this.state.resLokasi;
        let checkParent = this.state.resLokasiParent;

        console.log(check)
        console.log(checkParent)
        if (check == "") {
            //lokasi kosong tidak dipakai RS
            formIsValid = true;
            // console.log("1")
        } else {
            // console.log("2")
            //lokasi aktif
            formIsValid = false;
            this.setState({ ShowModalDelErr: true, ShowModalDel: false })
            // this.setState({ ShowModalDel: false })
        }
        return formIsValid
    }

    //HAPUS LOKASI
    hapusHandler = async (_id) => {
        const respond = await LocationService.getById(_id)
        const resLokasi = await LocationService.cekWilayahByNameLocation(respond.result.name)
        const resLokasiParent = await LocationService.cekWilayahByNameParent(respond.result.name)

        console.log(respond.result)
        console.log(resLokasi.result)
        console.log(resLokasiParent.result)

        if (resLokasiParent.result == undefined) {
            this.setState({
                // resLokasi: "",
                resLokasiParent: "",
            })
            if (resLokasi.result == undefined) {
                this.setState({
                    resLokasi: "",
                })
            } else {
                this.setState({
                    resLokasi: resLokasi.result.lokasi,
                })
            }

        } else {
            this.setState({
                // resLokasi: resLokasi.result.lokasi,
                resLokasiParent: resLokasiParent.result.parent,
            })
        }

        this.setState({
            Mode: "Hapus Lokasi",
            ShowModalDel: true,
            // resLokasi: resLokasi.result.lokasi
            // ShowModalDelErr: true
        })


        if (respond.success) {
            this.setState({
                Model: respond.result
            })
        }
    }


    render() {
        const { List, ListLocationLevel, Model, ShowModal, errors, Mode, ListLocation, ListLocation2 } = this.state
        // const { changeHandler} = this.props

        return (
            <div>
                <div class="container">
                    <div class="text-center">
                        <br />
                        <h1>Lokasi</h1>
                    </div>
                    <br /><br />

                    <div class="input-group col-4 mb-1 float-left">
                        <input class="form-control rounded-left miring floating" type="text" placeholder="cari berdasarkan nama" onChange={this.filterHandler("search1")} />
                        <div class="input-group-append">
                            <button class="btn btn-primary rounded-right" type="button" onClick={this.loadlist}>
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>

                    {/* //reset search */}
                    {/* <div class="input-group col-2 mb-1 float-left">
                            <button class="btn btn-primary rounded-right" type="button" onClick={this.cancelHandlerReset}>
                                Search Ulang
                            </button>
                        </div>
                    </div> */}


                    {/* //DROPWDOWN value */}
                    <div class="input-group col-4 mb-1 float-left lebar">
                        <div class="col-sm-12 form-group form-focus select-focus focused lebar ">
                            <div class="row">
                                {/* <label for="level_lokasi" class="form-label">Level Lokasi</label> <br /> */}
                                {/* <button class="lebar" type="button" onClick={this.loadlist}> */}
                                <select class="form-select lebar col-sm-12 mb-0 abu" type="button" style={{ height: 40 }} id="level_lokasi" onChange={this.filterHandler2("search2")} onClick={this.loadlist}>
                                    {/* <button class="btn btn-primary rounded-right" type="button" onClick={this.loadlist}> */}
                                    <option class="hitam" selected hidden>level lokasi</option>
                                    <option class="hitam" value="">--semua level lokasi--</option>
                                    {ListLocationLevel.map(data => {
                                        return (
                                            <option >{data.name}</option>
                                            // <option  onClick={this.loadlist} value={data._id}>{data.name}</option>
                                        )
                                    })}
                                    {/* </button> */}
                                </select>

                                <span class="dropdown-wrapper" aria-hidden="true"></span>
                            </div>
                        </div>
                    </div>


                    {/* <button type="button" class="btn col-4 float-right " onClick={this.createHandler}><i class="fa fa-plus biru" ></i>
                        <i> </i><i> </i><i class="biru">Tambah Lokasi</i></button> */}
                    <button type="button" class="btn col-4 btn-success mb-3 float-right tambah" style={{ height: 39 }} onClick={this.createHandler}><i class="fa fa-plus" ></i>
                        <i> </i>Tambah Lokasi</button>

                    <table class="table table-striped">
                        <thead>
                            <tr class="text-center bg-primary thead-warna">

                                <th scope="col">Nama</th>
                                <th scope="col">Level Lokasi</th>
                                <th scope="col">Wilayah</th>
                                <th scope="col">#</th>

                            </tr>
                        </thead>
                        <tbody>
                            {
                                List.map(data => {
                                    return (
                                        ListLocation2.map(data2 => {
                                            if (data.location_id == data2._id) {
                                                return (
                                                    <tr class="text-center">
                                                        <td class="table-primary">{data2.name}</td>
                                                        <td class="table-primary">{data2.location_level_name}</td>
                                                        {/* <td>{data.parent}</td> */}
                                                        <td class="table-primary">{data2.abb_parent} {data2.parent}</td>
                                                        {/* <td><img width="28" height="28" src="assets/img/user.jpg" class="rounded-circle m-r-5" alt="" /> Denise Stevens</td> */}

                                                        <td class="table-primary">
                                                            <button type="button" class="btn btn-primary mr-2" onClick={() => this.editHandler(data2._id)}>Ubah</button>
                                                            <button type="button" class="btn btn-danger" onClick={() => this.hapusHandler(data2._id)}>Hapus</button>
                                                            {/* <button type="button" class="btn fa fa-pencil m-r-5" onClick={() => this.editHandler(data._id)}></button> */}
                                                            {/* <button type="button" class="btn fa fa-trash-o m-r-5" onClick={() => this.hapusHandler(data._id)}></button> */}
                                                        </td>
                                                    </tr>

                                                )
                                            }

                                        })
                                        // <tr class="text-center">
                                        //     <td class="table-primary">{data.name}</td>
                                        //     <td class="table-primary">{data.location_level_name}</td>
                                        //     {/* <td>{data.parent}</td> */}
                                        //     <td class="table-primary">{data.abb_parent} {data.parent}</td>
                                        //     {/* <td><img width="28" height="28" src="assets/img/user.jpg" class="rounded-circle m-r-5" alt="" /> Denise Stevens</td> */}

                                        //     <td class="table-primary">
                                        //         <button type="button" class="btn btn-primary mr-2" onClick={() => this.editHandler(data._id)}>Ubah</button>
                                        //         <button type="button" class="btn btn-danger" onClick={() => this.hapusHandler(data._id)}>Hapus</button>
                                        //         {/* <button type="button" class="btn fa fa-pencil m-r-5" onClick={() => this.editHandler(data._id)}></button> */}
                                        //         {/* <button type="button" class="btn fa fa-trash-o m-r-5" onClick={() => this.hapusHandler(data._id)}></button> */}
                                        //     </td>
                                        // </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    <div class="row">
                        {/*Menampilkan total data entry*/}
                        {/* <div class="col-sm-12 col-md-5 float-left">
                            <div class="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 1 to 5 of 5 entries</div>
                        </div> */}


                        {/* <div class="col-sm-12 col-md-7 float-right">
                            <div class="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate">
                                <ul class="pagination float-right">
                                    <li class="paginate_button page-item previous disabled" id="DataTables_Table_0_previous">
                                        <a href="#" aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0" class="page-link">Previous</a>
                                    </li><li class="paginate_button page-item active">
                                        <a href="#" aria-controls="DataTables_Table_0" data-dt-idx="1" tabindex="0" class="page-link">1</a>
                                    </li>
                                    <li class="paginate_button page-item next disabled" id="DataTables_Table_0_next">
                                        <a href="#" aria-controls="DataTables_Table_0" data-dt-idx="2" tabindex="0" class="page-link">Next</a>
                                    </li>
                                </ul>
                            </div>
                        </div> */}
                    </div>
                    <div class="container">
                        <div class="mailbox-controls float-left">
                            <div class="btn-group">
                                <div className="input-goup-append">
                                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                                        Show Data
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li><a href="#" onClick={() => this.pageSizeHandler('5')} className="dropdown-item">5</a></li>
                                        <li><a href="#" onClick={() => this.pageSizeHandler('10')} className="dropdown-item">10</a></li>
                                        <li><a href="#" onClick={() => this.pageSizeHandler('20')} className="dropdown-item">20</a></li>
                                        <li><a href="#" onClick={() => this.pageSizeHandler('30')} className="dropdown-item">30</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* <div class="col-7"></div> */}
                        <div class="float-right">
                            {this.renderPagination()}
                        </div>
                    </div>


                    {/* <FormInput /> */}
                    <FormInput
                        changeHandler={this.changeHandler}
                        // checkedHandler={this.checkedHandler}
                        saveHandler={this.saveHandler}
                        editHandler={this.editHandler}
                        Model={Model}
                        ShowModal={ShowModal}
                        List={this.state.List}
                        ListLocationLevel={this.state.ListLocationLevel}
                        ListLocation={this.state.ListLocation}
                        ListLocation2={this.state.ListLocation2}
                        createHandler={this.createHandler}
                        cancelHandler={this.cancelHandler}
                        handleValidation={this.handleValidation}
                        errors={errors}
                        Mode={Mode}

                    />
                    {/* //mengirim changeHandle ke FOrmInput */}

                    {/* <FormInput /> */}
                    <ModalHapus
                        changeHandler={this.changeHandler}
                        createHandler={this.createHandler}
                        ShowModalDel={this.state.ShowModalDel}
                        cancelHandler={this.cancelHandler}
                        saveHandler={this.saveHandler}
                        List={List}
                        Model={this.state.Model}
                        errors={errors}
                    />

                    <ModalHapusError
                        changeHandler={this.changeHandler}
                        createHandler={this.createHandler}
                        ShowModalDel={this.state.ShowModalDel}
                        ShowModalDelErr={this.state.ShowModalDelErr}
                        cancelHandler={this.cancelHandler}
                        saveHandler={this.saveHandler}
                        List={List}
                        Model={this.state.Model}
                        errors={errors}
                    />

                    <ModalEditError
                        changeHandler={this.changeHandler}
                        createHandler={this.createHandler}
                        ShowModalDel={this.state.ShowModalDel}
                        ShowModalEditErr={this.state.ShowModalEditErr}
                        cancelHandler={this.cancelHandler}
                        saveHandler={this.saveHandler}
                        List={List}
                        Model={this.state.Model}
                        errors={errors}
                    />

                    <ModalHapusBerhasil
                        changeHandler={this.changeHandler}
                        createHandler={this.createHandler}
                        ShowModalDel={this.state.ShowModalDel}
                        ShowModalDelBerhasil={this.state.ShowModalDelBerhasil}
                        cancelHandler={this.cancelHandler}
                        saveHandler={this.saveHandler}
                        List={List}
                        Model={this.state.Model}
                        errors={errors}
                    />

                    <ModalBerhasilSimpan
                        changeHandler={this.changeHandler}
                        createHandler={this.createHandler}
                        ShowModalDel={this.state.ShowModalDel}
                        ShowModalBerhasilSimpan={this.state.ShowModalBerhasilSimpan}
                        cancelHandler={this.cancelHandler}
                        saveHandler={this.saveHandler}
                        List={List}
                        Model={this.state.Model}
                        errors={errors}
                    />

                    <ModalGagalSimpan
                        changeHandler={this.changeHandler}
                        createHandler={this.createHandler}
                        ShowModalDel={this.state.ShowModalDel}
                        ShowModalGagalSimpan={this.state.ShowModalGagalSimpan}
                        cancelHandler={this.cancelHandler}
                        saveHandler={this.saveHandler}
                        List={List}
                        Model={this.state.Model}
                        errors={errors}
                    />

                    <ModalBerhasilUbah
                        changeHandler={this.changeHandler}
                        createHandler={this.createHandler}
                        ShowModalDel={this.state.ShowModalDel}
                        ShowModalBerhasilUbah={this.state.ShowModalBerhasilUbah}
                        cancelHandler={this.cancelHandler}
                        saveHandler={this.saveHandler}
                        List={List}
                        Model={this.state.Model}
                        errors={errors}
                    />

                </div>

            </div >
        )
    }
}


